import { UserActions } from './user.actions';

export const initialState = [];

export function UserReducer(state: any = initialState, action) {

    switch (action.type) {

        case UserActions.ADD_USERS:
            return action.payload.users;

        case UserActions.ADD_USER:
            return [...state, action.payload.user];

        case UserActions.EDIT_USER:
            return state.map((u, i) => {
                if (u.id === action.payload.id) {
                    return { ...u, ...action.payload.user };
                }
                return u;
            });

        case UserActions.REMOVE_USER:
            return state.filter((u, i) => u.id !== action.payload.id);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/states/user/user.reducer.ts